import React, { Component } from 'react';
import actions from '../actions';
import visitsActions from '../../visits/actions';
import sharedActions from '../../../baseApp/shared/actions';
import { connect } from 'react-redux';
import VisitorsForm from './../components/VisitorsForm';
import Validators from './../../../baseApp/shared/utils/Validators';
import { I18n } from 'react-redux-i18n';
import _ from '../../../baseApp/shared/utils/ObjectUtils';

class VisitorsFormContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            viewMode: !_.isNilOrEmpty(props.visitorId),
            editMode: false,
            alert: {
                show: false
            },
            visitorFormData: {
                name: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
                email: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
                companyName: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
                mobilePhone: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
            }
        }
    }

    componentDidMount() {
        const { visitorId, getVisitorData, getVisitorLastVisits } = this.props;
        if (visitorId) {
            getVisitorData(visitorId);
            getVisitorLastVisits(visitorId);
        }
    };

    componentWillUnmount() {
        this.props.updateCustomTitle();
        this.props.updateCustomBreadcrumbs();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.loadingEditRequest && !nextProps.loadingEditRequest) {
            if (nextProps.visitorWasEdited) {
                this.handleVisitorEditSuccess()
            } else {
                this.handleVisitorEditError(nextProps.error)
            }
        } else if (this.props.loadingVisitor && !nextProps.loadingVisitor) {
            this.handleVisitorLoadingCompleted(nextProps.visitorData)
        }
    };

    handleVisitorLoadingCompleted = visitorData => {
        const {
            updateCustomTitle,
            updateCustomBreadcrumbs
        } = this.props;

        const visitorDescription = _.isNilOrEmpty(visitorData.name) ? visitorData.email : visitorData.name;

        updateCustomTitle(visitorDescription);
        updateCustomBreadcrumbs([{
            link: "/visitors",
            name: I18n.t('routes.visitors')
        }, {
            link: "/visitors/" + visitorData.id,
            name: visitorDescription
        }]);

        this.setState({
            ...this.state,
            visitorFormData: {
                ...this.state.visitorFormData,
                ...Object.entries(visitorData).reduce(
                    (acc, keyValuePair) => ({
                        ...acc,
                        [keyValuePair[0]]: {
                            ...acc[keyValuePair[0]],
                            ...this.state.visitorFormData[keyValuePair[0]],
                            value: keyValuePair[1]
                        }
                    }), {})
            }
        })
    };

    handleFieldChange = (id, value) => {
        this.setState({
            visitorFormData: {
                ...this.state.visitorFormData,
                [id]: {
                    ...this.state.visitorFormData[id],
                    value: value
                }
            }
        }, () => {
            if (_.has(this.state.visitorFormData[id], 'required')) {
                this.validateField(id);
            }
        })
    };

    validateField = (key) => {
        let { visitorFormData } = this.state;
        let error = null;
        switch (key) {
            case "email":
                error = !Validators.email(visitorFormData[key].value) ? I18n.t('forms.errors.invalidEmail') : undefined;
                break;
            case "mobilePhone":
                error = !Validators.isInteger(visitorFormData[key].value) ? I18n.t('forms.errors.notAnInteger') : undefined;
                break;
            default:
                if (!_.isNilOrEmpty(visitorFormData[key].error) &&
                    visitorFormData[key].required &&
                    !_.isNilOrEmpty(visitorFormData[key].value)) {
                    error = undefined;
                } else if (visitorFormData[key].required &&
                    _.isNilOrEmpty(visitorFormData[key].value)) {
                    error = I18n.t('forms.errors.emptyRequiredField')
                }
                break;
        }
        if (error !== visitorFormData[key].error) {
            visitorFormData[key].error = error;
            this.setState({
                visitorFormData,
            });
        }
    };

    handleOnFieldBlur = (key) => {
        this.validateField(key)
    };

    handleSubmitClick = () => {
        let { editMode, visitorFormData } = this.state;
        const { visitorId, editVisitor } = this.props;
        let formHasErrors = false;

        _.forOwn(visitorFormData, field => {
            if ((field.required && _.isNilOrEmpty(field.value))) {
                field.error = I18n.t('forms.errors.emptyRequiredField');
                formHasErrors = true;
            } else if (!_.isNilOrEmpty(field.error)) {
                formHasErrors = true;
            } else {
                field.error = undefined;
            }
        })

        if (!formHasErrors) {
            const formDataToBeSubmitted = Object.entries(visitorFormData).reduce((acc, keyValuePair) => {
                return {
                    ...acc,
                    [keyValuePair[0]]: keyValuePair[1].value,
                }
            }, {});
            if (editMode) {
                this.setState({
                    alert: {
                        show: true,
                        type: "warning",
                        title: I18n.t('visitors.alerts.edit.title'),
                        html: I18n.t('visitors.alerts.edit.text', { visitor: formDataToBeSubmitted.name }),
                        confirmButtonText: I18n.t('forms.submit'),
                        cancelButtonText: I18n.t('forms.cancel'),
                        onCancel: this.hideAlert,
                        onConfirm: () => {
                            editVisitor(visitorId, formDataToBeSubmitted)
                        }
                    }
                })
            }
        } else {
            this.setState({
                visitorFormData,
            });
        }
    };

    handleEditClick = () => {
        const { editMode } = this.state;
        const { visitorData } = this.props;

        if (editMode) {
            this.setState({
                ...this.state,
                editMode: false,
                viewMode: true,
                visitorFormData:
                    Object.entries(this.state.visitorFormData).reduce((acc, keyValuePair) => {
                        return {
                            ...acc,
                            [keyValuePair[0]]: {
                                ...this.state.visitorFormData[keyValuePair[0]],
                                value: visitorData[keyValuePair[0]] ? visitorData[keyValuePair[0]] : undefined,
                                error: undefined,
                            }
                        }
                    }, {})
            })
        } else {
            this.setState({
                viewMode: false,
                editMode: true
            })
        }
    };

    hideAlert = () => {
        this.setState({
            alert: {
                show: false
            }
        })
    };

    handleBackClick = () => {
        this.props.resetVisitorForm();
        this.hideAlert();
        this.props.history.push({
            pathname: '/visitors', 
            state: { 
                searchFieldsData : this.props.location.state?.searchFieldsData, 
                universalSearchField :  this.props.location.state?.universalSearchField
            }
        });
    };

    handleVisitorEditSuccess = () => {
        const {
            visitorFormData: {
                name: {
                    value: name
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('visitors.alerts.edit.success.title'),
                html: I18n.t('visitors.alerts.edit.success.text', { visitor: name }),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    };

    handleVisitorEditError = () => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('visitors.alerts.edit.error.title'),
                html: I18n.t('visitors.alerts.edit.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };

    render() {
        const { editMode, viewMode, visitorFormData, alert } = this.state;
        const {
            visitorLastVisits: {
                data,
            },
            loadingEditRequest
        } = this.props;

        return <VisitorsForm
            editMode={editMode}
            viewMode={viewMode}
            alert={{
                ...alert,
                loading: loadingEditRequest
            }}

            visitorFormData={visitorFormData}

            data={data}

            handleFieldChange={this.handleFieldChange}
            handleOnFieldBlur={this.handleOnFieldBlur}
            handleSubmitClick={this.handleSubmitClick}

            handleEditClick={this.handleEditClick}
            handleBackClick={this.handleBackClick}
        />
    }
}

const mapStateToProps = ({ visitorsReducer, visitsReducer }) => {
    return {

        visitorData: visitorsReducer.visitorData,
        loadingVisitor: visitorsReducer.loading,
        error: visitorsReducer.error,

        loadingEditRequest: visitorsReducer.loadingEditRequest,
        visitorWasEdited: visitorsReducer.visitorWasEdited,

        visitorLastVisits: visitsReducer.visitorLastVisitsTable,
    };
};

const mapDispatchToProps = {
    getVisitorData: actions.getVisitorData,
    editVisitor: actions.editVisitor,
    resetVisitorForm: actions.resetVisitorForm,
    getVisitorLastVisits: visitsActions.getVisitorLastVisits,

    updateCustomTitle: sharedActions.updateCustomTitle,
    updateCustomBreadcrumbs: sharedActions.updateCustomBreadcrumbs
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VisitorsFormContainer);
